import { types } from 'mobx-state-tree';

export const CompletionDate = types
  .model({
    completionDate: types.maybe(
      types.array(
        types.model({
          taskId: types.maybe(types.string),
          date: types.maybe(types.string),
        }),
      ),
    ),
  })
  .views(self => ({
    get getCompletedDate() {
      const index = self.completionDate?.findIndex(
        item => item.taskId === localStorage.getItem('taskId'),
      );
      if (index !== -1 && self.completionDate && index !== undefined)
        return self.completionDate[index];
      else return {};
    },
  }))
  .actions(self => ({
    updateCompletionDate: (data: { taskId: string; date: string }) => {
      const index = self.completionDate?.findIndex(item => item.taskId === data.taskId);

      if (index !== -1 && self.completionDate && index !== undefined) {
        self.completionDate[index] = {
          taskId: data.taskId,
          date: data.date,
        };
      } else {
        self.completionDate?.push({
          taskId: data.taskId,
          date: data.date,
        });
      }
    },
  }));

export default CompletionDate;
